import React from 'react';
import Header from './Header';
import Banner from '@/shared/components/Banner';
import {useTestsPatientSync} from '@/modules/patient-dashboard/hooks/useTestsQuery';

interface DashboardLayoutProps {
    children: React.ReactNode;
    headerAction?: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({children, headerAction}) => {
    // Fetch /api/user/data + extract patients into patientSlice exactly once per
    // dashboard mount (React Query handles focus-refetch + impersonation switch).
    useTestsPatientSync();

    return (
        <div className="bg-mld-background min-h-screen">
            <Header rightAction={headerAction} />
            <div className="relative">
                <Banner />
                <main className="mx-auto w-full max-w-[1760px] px-4 sm:px-6 xl:px-10 py-12">{children}</main>
                {/* Footer will go here */}
            </div>
        </div>
    );
};

export default DashboardLayout;
